import {
  IconButton as PrimitiveIconButton,
  type IconButtonProps as PrimitiveIconButtonProps,
} from "../ui/primitives/icon-button";

/**
 * @deprecated Import `IconButton` from `src/components/ui` instead.
 * Legacy wrapper removal is deferred by `UI-MIG-LEGACY-002`.
 */
export type IconButtonProps = PrimitiveIconButtonProps;

/**
 * @deprecated Import `IconButton` from `src/components/ui` instead.
 * Legacy wrapper removal is deferred by `UI-MIG-LEGACY-002`.
 */
export function IconButton(props: IconButtonProps) {
  return <PrimitiveIconButton {...props} />;
}
